(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-section"]) return;
  try {
      
var swiper3;

function swiperCardColl() {
  if (document.querySelector(".product-images.swiper")) {
    if (window.innerWidth <= 575) {
      console.log("initSwiper");
      swiper3 = new Swiper(".product-images.swiper", {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 1
      });
    } else {
      if (swiper3) {
        swiper3.destroy(true, true);
        swiper3 = null;
      }
    }
  }
}

swiperCardColl();
document.addEventListener('DOMContentLoaded', function () {
  swiperCardColl();
  window.addEventListener("resize", swiperCardColl);
});


var lastScroll = 0;
window.addEventListener('scroll', function() {
  var topHeader = document.querySelector('#collection-grid');
  var sPage = topHeader.offsetTop - window.pageYOffset;
  if (sPage < 0) {
    let scrollCount = window.pageYOffset;
    if (scrollCount > lastScroll) {
      document.querySelector('body').classList.remove('up');
      document.querySelector('body').classList.add('down');
    } else if (scrollCount < lastScroll) {
      document.querySelector('body').classList.remove('down');
      document.querySelector('body').classList.add('up');
    }
    lastScroll = scrollCount;
  }else{
    document.querySelector('body').classList.remove('up');
  }
  
});  

var advance = function advance() {
    if(typeof quickAddButton == 'function'){
      quickAddButton();
    }

    swiperCardColl();
  }
  var infinitescroll = {
    scolljs: function(){
      var endlessScroll = new Ajaxinate({
        container: '#product-grid',
        pagination: '#AjaxinatePagination',
        loadingText: document.getElementById('AjaxinatePagination').dataset.text,
        callback: swiperCardColl, advance,
        //offset: 200
      });
    }
  }
  infinitescroll.scolljs();
  document.addEventListener('scroll', function(e) {
  	var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
    var pos = document.documentElement.scrollTop;
    sessionStorage.setItem('scrollPos',pos)
	//sessionStorage.scrollPos = document.documentElement.scrollTop;
	sessionStorage.totalpage = totalpage;
  });


  if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
     var scrollTop= sessionStorage.getItem('scrollPos')
	 
    var buttonTop = document.querySelector('#AjaxinatePagination');
    var buttonScroll = buttonTop.offsetTop - window.scrollY;
	document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;

   // window.scrollTo(0, 0);
      if(buttonScroll < scrollTop) {
      var buttonScroll = buttonTop.offsetTop - window.scrollY ;
    	scrollManualy(buttonScroll);
    } else {
       scrollManualy(scrollTop);
    }

	function scrollManualy(scrollTop1){
    
		scrollTop1 = parseInt(scrollTop1);
		window.scrollTo(0,scrollTop1)
 		setTimeout(function(){
          if(buttonScroll < scrollTop) {
          buttonScroll = buttonTop.offsetTop ;
          	scrollManualy(buttonScroll);
          } else {  
          	//scrollManualy(scrollTop);
            window.scrollTo(0,scrollTop)
            return false;
          }
          // if(window.scrollY < buttonScroll){
          //     scrollManualy(scrollTop)
          // }
		},500);
      
	 }
   
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-slider"] && !Shopify.designMode) return;
  try {
    
	function mediaslider() {
		var mediaslider = [];
		document.querySelectorAll('.media-slider').forEach(function(Element, index) {
		var mediaid = Element.dataset.id;
		var media_autoplay = Element.dataset.autoplay;
		var isSingle = Element.dataset.single === 'true';
		let swiperObject = {
		loop: !isSingle,
		simulateTouch: eval(Element.dataset.draggable),
		navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
		},
		on: {
		init: function() {
		// Unmute the video in the initial active slide if it has the data-unmute-video attribute
		const initialActiveSlide = this.slides[this.activeIndex];
		if (initialActiveSlide && initialActiveSlide.classList.contains('swiper-slide-active') &&
		initialActiveSlide.getAttribute('data-unmute-video') === 'true') {
		unmuteVideosInSlide(initialActiveSlide);
		}
		},
		slideChange: function() {
		// Mute videos in the previous slide if it has the data-unmute-video attribute
		const previousSlide = this.slides[this.previousIndex];
		if (previousSlide && previousSlide.getAttribute('data-unmute-video') === 'true') {
		muteVideosInSlide(previousSlide);
		}

		// Unmute video in the active slide if it has the data-unmute-video attribute
		const activeSlide = this.slides[this.activeIndex];
		if (activeSlide && activeSlide.getAttribute('data-unmute-video') === 'true') {
		unmuteVideosInSlide(activeSlide);
		}
		},
		},
		};

		// Function to mute all videos in a given slide
		function muteVideosInSlide(slide) {
		const video = slide.querySelector('video');
		video.muted = true;
		}

		// Function to unmute all videos in a given slide
		function unmuteVideosInSlide(slide) {
		const video = slide.querySelector('video');
		video.muted = false;
		}

		if (eval(media_autoplay) == true) {
		swiperObject.autoplay = {
		delay: eval(Element.dataset.playtime)
		}
		}

		mediaslider[mediaid] = new Swiper(Element, swiperObject);
		});
	}

	mediaslider();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }    		
              var productslider=[];
              document.querySelectorAll('.product-carousel').forEach(function(Element,index){    
                let productid = Element.dataset.id;
                let outer_carousel = Element.closest('.carousel-rowouter');
                let swiperObject={
                  loop:eval(Element.dataset.loop),
                  spaceBetween: 20,
                  enabled:true,
                  freeMode: true,
                  breakpoints: {
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 5,
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: 4,
                    }
                  },
                  scrollbar: {
                    el: ".swiper-scrollbar",
                  }
                };    
                productslider[productid]=new Swiper(Element,swiperObject);
              }); 
              if(typeof quickAddButton == 'function'){
              quickAddButton();
              }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
